const canUpdateOutput = ({
  hasUpdatePermission, output, editingMode


}) => {
  if (!hasUpdatePermission) {return false;}

  if (editingMode) {return true;}

  return output.status.name === 'DRAFT';
};

export default canUpdateOutput;